import React, { useEffect, useState } from 'react';
import { Spin, Col, Row } from 'antd';
import { api, endpoints } from '../../api';
import { BlueLayout, CustomFormLayout, FormBlock, FormItem, OpenFileLink, PagesContainerUI } from '../../styles/styled';
import { RepresentativeType, UserDataResponseType } from '../../types';

export const RepresentativeProfilePage = () => {
  const [currentRepresentativeState, setCurrentRepresentative] = useState<RepresentativeType | null>();

  useEffect(() => {
    (async () => {
      try {
        const idResponse = await api.get<UserDataResponseType>(endpoints.getUserData());

        if (idResponse) {
          const representativeResponse = await api.get<RepresentativeType>(
            endpoints.getRepresentativeById(idResponse.data.representative.id),
          );

          setCurrentRepresentative(representativeResponse.data);
        }
      } catch (err) {}
    })();
  }, []);

  return currentRepresentativeState ? (
    <PagesContainerUI>
      <BlueLayout>{` ${currentRepresentativeState?.last_name} ${currentRepresentativeState?.first_name}`}</BlueLayout>
      <FormBlock white>
        <Row gutter={[15, 15]}>
          <Col span={24}>
            <CustomFormLayout color="#378dda">Контактная информация</CustomFormLayout>
          </Col>
          <Col span={8}>
            <FormItem>
              <p>Телефон</p>
              {currentRepresentativeState?.phone}
            </FormItem>
          </Col>
          <Col span={8}>
            <FormItem>
              <p>Email</p>
              {currentRepresentativeState?.email}
            </FormItem>
          </Col>
          <Col span={8} />
          <Col span={24}>
            <CustomFormLayout padding="0" color="#378dda">
              Издательство
            </CustomFormLayout>
            {currentRepresentativeState?.publisher.title}
          </Col>

          <Col span={24}>
            <CustomFormLayout padding="0" color="#378dda">
              Подтверждение полномочий
            </CustomFormLayout>

            <OpenFileLink href={currentRepresentativeState?.file.file_path} target="_blank" rel="noreferrer">
              Открыть
            </OpenFileLink>
          </Col>
        </Row>
      </FormBlock>
    </PagesContainerUI>
  ) : (
    <Spin />
  );
};
